/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/bankreconciliation/service.proto" (package "rd.api.bankreconciliation", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { BankReconciliationService } from "./service_pb";
import type { ImportAndValidateStatementRes } from "./service_pb";
import type { ImportAndValidateStatementReq } from "./service_pb";
import type { PrintReconciliationPDFRes } from "./service_pb";
import type { PrintReconciliationPDFReq } from "./service_pb";
import type { UpdateReconciliationMatchesRes } from "./service_pb";
import type { UpdateReconciliationMatchesReq } from "./service_pb";
import type { RecordMatchingTransactionRes } from "./service_pb";
import type { RecordMatchingTransactionReq } from "./service_pb";
import type { ReopenReconciliationRes } from "./service_pb";
import type { ReopenReconciliationReq } from "./service_pb";
import type { VoidReconciliationRes } from "./service_pb";
import type { VoidReconciliationReq } from "./service_pb";
import type { CompleteReconciliationRes } from "./service_pb";
import type { CompleteReconciliationReq } from "./service_pb";
import type { GetReconciliationRes } from "./service_pb";
import type { GetReconciliationReq } from "./service_pb";
import type { CreateReconciliationRes } from "./service_pb";
import type { CreateReconciliationReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListAccountsAndReconciliationsRes } from "./service_pb";
import type { ListAccountsAndReconciliationsReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.bankreconciliation.BankReconciliationService
 */
export interface IBankReconciliationServiceClient {
    /**
     * @generated from protobuf rpc: ListAccountsAndReconciliations
     */
    listAccountsAndReconciliations(input: ListAccountsAndReconciliationsReq, options?: RpcOptions): UnaryCall<ListAccountsAndReconciliationsReq, ListAccountsAndReconciliationsRes>;
    /**
     * @generated from protobuf rpc: CreateReconciliation
     */
    createReconciliation(input: CreateReconciliationReq, options?: RpcOptions): UnaryCall<CreateReconciliationReq, CreateReconciliationRes>;
    /**
     * @generated from protobuf rpc: GetReconciliation
     */
    getReconciliation(input: GetReconciliationReq, options?: RpcOptions): UnaryCall<GetReconciliationReq, GetReconciliationRes>;
    /**
     * @generated from protobuf rpc: CompleteReconciliation
     */
    completeReconciliation(input: CompleteReconciliationReq, options?: RpcOptions): UnaryCall<CompleteReconciliationReq, CompleteReconciliationRes>;
    /**
     * @generated from protobuf rpc: VoidReconciliation
     */
    voidReconciliation(input: VoidReconciliationReq, options?: RpcOptions): UnaryCall<VoidReconciliationReq, VoidReconciliationRes>;
    /**
     * @generated from protobuf rpc: ReopenReconciliation
     */
    reopenReconciliation(input: ReopenReconciliationReq, options?: RpcOptions): UnaryCall<ReopenReconciliationReq, ReopenReconciliationRes>;
    /**
     * @generated from protobuf rpc: RecordMatchingTransaction
     */
    recordMatchingTransaction(input: RecordMatchingTransactionReq, options?: RpcOptions): UnaryCall<RecordMatchingTransactionReq, RecordMatchingTransactionRes>;
    /**
     * @generated from protobuf rpc: UpdateReconciliationMatches
     */
    updateReconciliationMatches(input: UpdateReconciliationMatchesReq, options?: RpcOptions): UnaryCall<UpdateReconciliationMatchesReq, UpdateReconciliationMatchesRes>;
    /**
     * @generated from protobuf rpc: PrintReconciliationPDF
     */
    printReconciliationPDF(input: PrintReconciliationPDFReq, options?: RpcOptions): UnaryCall<PrintReconciliationPDFReq, PrintReconciliationPDFRes>;
    /**
     * @generated from protobuf rpc: ImportAndValidateStatement
     */
    importAndValidateStatement(input: ImportAndValidateStatementReq, options?: RpcOptions): UnaryCall<ImportAndValidateStatementReq, ImportAndValidateStatementRes>;
}
/**
 * @generated from protobuf service rd.api.bankreconciliation.BankReconciliationService
 */
export class BankReconciliationServiceClient implements IBankReconciliationServiceClient, ServiceInfo {
    typeName = BankReconciliationService.typeName;
    methods = BankReconciliationService.methods;
    options = BankReconciliationService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ListAccountsAndReconciliations
     */
    listAccountsAndReconciliations(input: ListAccountsAndReconciliationsReq, options?: RpcOptions): UnaryCall<ListAccountsAndReconciliationsReq, ListAccountsAndReconciliationsRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAccountsAndReconciliationsReq, ListAccountsAndReconciliationsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateReconciliation
     */
    createReconciliation(input: CreateReconciliationReq, options?: RpcOptions): UnaryCall<CreateReconciliationReq, CreateReconciliationRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateReconciliationReq, CreateReconciliationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetReconciliation
     */
    getReconciliation(input: GetReconciliationReq, options?: RpcOptions): UnaryCall<GetReconciliationReq, GetReconciliationRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReconciliationReq, GetReconciliationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CompleteReconciliation
     */
    completeReconciliation(input: CompleteReconciliationReq, options?: RpcOptions): UnaryCall<CompleteReconciliationReq, CompleteReconciliationRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CompleteReconciliationReq, CompleteReconciliationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: VoidReconciliation
     */
    voidReconciliation(input: VoidReconciliationReq, options?: RpcOptions): UnaryCall<VoidReconciliationReq, VoidReconciliationRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<VoidReconciliationReq, VoidReconciliationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReopenReconciliation
     */
    reopenReconciliation(input: ReopenReconciliationReq, options?: RpcOptions): UnaryCall<ReopenReconciliationReq, ReopenReconciliationRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReopenReconciliationReq, ReopenReconciliationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RecordMatchingTransaction
     */
    recordMatchingTransaction(input: RecordMatchingTransactionReq, options?: RpcOptions): UnaryCall<RecordMatchingTransactionReq, RecordMatchingTransactionRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<RecordMatchingTransactionReq, RecordMatchingTransactionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateReconciliationMatches
     */
    updateReconciliationMatches(input: UpdateReconciliationMatchesReq, options?: RpcOptions): UnaryCall<UpdateReconciliationMatchesReq, UpdateReconciliationMatchesRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateReconciliationMatchesReq, UpdateReconciliationMatchesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PrintReconciliationPDF
     */
    printReconciliationPDF(input: PrintReconciliationPDFReq, options?: RpcOptions): UnaryCall<PrintReconciliationPDFReq, PrintReconciliationPDFRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<PrintReconciliationPDFReq, PrintReconciliationPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ImportAndValidateStatement
     */
    importAndValidateStatement(input: ImportAndValidateStatementReq, options?: RpcOptions): UnaryCall<ImportAndValidateStatementReq, ImportAndValidateStatementRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<ImportAndValidateStatementReq, ImportAndValidateStatementRes>("unary", this._transport, method, opt, input);
    }
}
